import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { safeError } from "@/utils/safeLogger";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    safeError("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen min-h-dvh items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-typo-title text-muted-foreground">Oops! Page not found</p>
        <a href="/home" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
